export default __webpack_public_path__ + "static/media/br.84b29e98.webp";